var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TedsLauncherUiSettings"},[_c('teds-spacer',{attrs:{"height":"40px"}}),_c('teds-launcher-upload-logo'),_c('teds-spacer',{attrs:{"height":"40px"}}),_c('teds-launcher-update-colors')],1)}
var staticRenderFns = []

export { render, staticRenderFns }